
    import { defineComponent } from 'vue';
    import XBreadcrumb from '@/apps/shared/components/breadcrumb.vue';
    import capitalRangeService from '@/apps/shared/services/capitalRange-service';
    import theftQuotationService from '@/apps/shared/services/theftQuotation-service';
    import ProductCardsSelector from '@/apps/shared/components/ProductCardsSelector.vue';
    import { TitleAndPromotionsDetails } from '@/apps/shared/models/titleAndPromotionsDetails';
    import webSaleHelper from '@/apps/shared/utils/webSaleHelper';

    export default defineComponent({
        components: {
            XBreadcrumb,
            ProductCardsSelector
        },

        busEvents: {
            Next: function (data) {
                //prevenir que el evento Next y otras acciones de navegación se ejecuten de forma redundante
                if (data.fromTab === 'tab-three') {
                    if (this.$refs.productCards && this.$refs.productCards.isNavigationAllowed) {  // Comprobamos si la navegación está permitida
                        this.createTheft1000Quotation();
                        this.$refs.productCards.isNavigationAllowed = false;  // Desactivamos la navegación
                    }
                }
            },
            SaveProductDataValueSession: function (value) {
                if (value.fromTab === 'tab-three') {
                    sessionStorage.removeItem('ProductValueSelected');
                    sessionStorage.setItem('ProductValueSelected', JSON.stringify(value));
                }
            },
        },

        data() {
            return {
                referente: null,
                medium: null,
                pas: null,
                productId: 1000,
                onDate: new Date().toISOString(),
                productCardsSelector: {
                    iconPromotion: null,
                    otherIconPromotion: null,
                    icon: null,
                    product: "",
                    tabName: "tab-three",
                    title: "Valor",
                    subTitle: "Seleccioná el rango de valor de tu equipo electrónico.",
                } as TitleAndPromotionsDetails,
                range: null,
                breadcrumItems: [
                    { text: 'Inicio', path: '/tecnologia' },
                    { text: 'Cotizador de Equipo Electrónico', path: '/tecnologia/cotizarEquipoElectronico' },
                    { text: 'Valor de tu dispositivo', path: '/tecnologia/valorEquipoElectronico' },
                ],
            }
        },
        methods: {
            async pageCustomization() {
                const defaultTitle = 'Tecnología';
                const actualPath = '/tecnologia';
                // Llamamos al helper que se encarga de toda la lógica
                try {
                    await webSaleHelper.pageCustomization(this.$route, this.Bus, this.$store, defaultTitle, actualPath, null, null);
                    const title = this.$store.getters.getWebSaleData?.pageCustomization?.navbar?.title ?? '';
                    this.pas = title === defaultTitle ? null : title;
                }
                catch (error) {
                    const statusCode = error.response.status;
                    this.Bus.$emit(
                        'show-service-fail',
                        statusCode,
                        [() => this.pageCustomization()]);
                }
            },

            updateByProductGoogleAnalytics() {
                window.globalThis.dataLayer = window.globalThis.dataLayer || [];
                const productGtmName = 'DefaultElectronicDeviceGTMInfo';
                this.Bus.$emit('updateByProductGoogleAnalytics', productGtmName);
            },
            createTheft1000Quotation: function () {
                var good = JSON.parse(sessionStorage.getItem("ProductDataSelected"));
                var rangeSelected = JSON.parse(sessionStorage.getItem("ProductValueSelected"));
                var tabOneWelcome = JSON.parse(sessionStorage.getItem("TabOneWelcome"));
                return new Promise<any>(async (resolve) => {
                    sessionStorage.removeItem("DataQuotation");
                    var quotationDataResult = [];
                    var rangeId = this.range;
                    var body = JSON.stringify({
                        goodTypeId: parseInt(good.code),
                        rangeId: rangeSelected.code,
                        cityId: parseInt(tabOneWelcome.selectedLocality.id),
                        zipCode: tabOneWelcome.selectedLocality.zipCode
                    });
                    await theftQuotationService.createTheft1000Quotation(body).then(async responseTheft1000Quotation => {
                        if (!responseTheft1000Quotation) {
                            NF.Notification.show({
                                type: NF.Notification.Type.ERROR,
                                title: 'Error',
                                content: 'Se produjo un error al cotizar.',
                                position: NF.Notification.Positions.TOP_RIGHT,
                                clickClose: true,
                                autoHideDelay: 10000,
                            });
                            this.$refs.productCards.isNavigationAllowed = true;
                            this.$refs.productCards.isNextTriggered = false;

                            const eventData = {
                                'pas': this.pas,
                                'email': JSON.parse(sessionStorage.getItem("TabOneWelcome")).email,
                                'product': 'tecnologia', 'event': 'errorServidor',
                                'paso': 'cotizador-tecnologia-valor',
                                'referente': this.referente,
                                'medio': this.medium
                            };

                            window.globalThis.dataLayer.push(eventData);

                            const customWindow = window as typeof window & {
                                _qsie?: Array<typeof eventData>;
                            };

                            customWindow._qsie ??= [];
                            customWindow._qsie.push(eventData);

                            NF.UI.Page.unblock();
                        } else {
                            const { plans, modulesPlan } = responseTheft1000Quotation;
                            const plansData = { plans, modulesPlan }
                            quotationDataResult.push(plansData);
                            sessionStorage.setItem("DataQuotation", JSON.stringify(quotationDataResult));
                            resolve(true)
                            this.$router.push({
                                name: 'electronic-equipment-plans-view',
                            })
                            NF.UI.Page.unblock();
                        }
                    }).catch(error => {
                        NF.UI.Page.unblock();
                        let statusCode = null;
                        // Si es un error de Axios (por ejemplo, 4xx, 5xx)
                        if (error.response && error.response.status) {
                            statusCode = error.response.status;
                        } else if (error.message === '204') {
                            // Error lanzado manualmente en el service para 204
                            statusCode = 204;
                        }

                        const eventData = {
                            'pas': this.pas,
                            'email': JSON.parse(sessionStorage.getItem("TabOneWelcome")).email,
                            'product': 'tecnologia',
                            'event': 'errorServidor',
                            'paso': 'cotizador-tecnologia-valor',
                            'referente': this.referente,
                            'medio': this.medium
                        };

                        window.globalThis.dataLayer.push(eventData);

                        const customWindow = window as typeof window & {
                            _qsie?: Array<typeof eventData>;
                        };

                        customWindow._qsie ??= [];
                        customWindow._qsie.push(eventData);

                        this.Bus.$emit('show-service-fail', statusCode, [() => this.createTheft1000Quotation()]);
                    });
                });
            },

            getCapitalRanges() {
                capitalRangeService.getCapitalRange(this.onDate, this.productId, '', '', '', '', '').then(response => {
                    if (!response) {
                        const eventData = {
                            'pas': this.pas,
                            'email': JSON.parse(sessionStorage.getItem("TabOneWelcome")).email,
                            'product': 'tecnologia',
                            'event': 'errorServidor',
                            'paso': 'cotizador-tecnologia-cotizacion',
                            'referente': this.referente,
                            'medio': this.medium
                        };

                        window.globalThis.dataLayer.push(eventData);

                        const customWindow = window as typeof window & {
                            _qsie?: Array<typeof eventData>;
                        };

                        customWindow._qsie ??= [];
                        customWindow._qsie.push(eventData);
                    }
                    else {
                        var productData = JSON.parse(sessionStorage.getItem("ProductValueSelected"));
                        var values = response.map(element => ({
                            ...element,
                            code: element["capitalRangeCode"],
                            productDescription: element["description"],
                            getProductDescription: productData && productData.productDescription
                        }));
                        this.$refs.productCards.setProductData(values);
                        NF.UI.Page.unblock();
                    }
                })
            },

            volver() {
                NF.UI.Page.block();
                sessionStorage.setItem("pressBack", "true");
                this.$router.push({
                    name: 'cotizador-equipo-electronico',
                })
            },
            getInitData() {
                sessionStorage.setItem("ExitOrContinueModal", "true");

                const eventData = {
                    'pas': this.pas,
                    'email': JSON.parse(sessionStorage.getItem("TabOneWelcome")).email,
                    'product': 'tecnologia',
                    'event': 'cotizador-tecnologia-cotizacion',
                    'referente': this.referente,
                    'medio': this.medium
                };

                window.globalThis.dataLayer.push(eventData);

                const customWindow = window as typeof window & {
                    _qsie?: Array<typeof eventData>;
                };

                customWindow._qsie ??= [];
                customWindow._qsie.push(eventData);

                sessionStorage.removeItem("DataQuotation");
                this.getCapitalRanges();
                var validBack = sessionStorage.getItem("pressBack");
                if (validBack) {
                    // Permite la navegación nuevamente cuando el componente regresa a este tab
                    this.$refs.productCards.resetNavigationFlag();
                    var productData = JSON.parse(sessionStorage.getItem("ProductValueSelected"));
                    if (productData) {
                        //Llama a la funcion de productCardsSelector.vue, luego de que regresan la pantalla y muestra la opcion elegida
                        this.$refs.productCards.getDataProductBack(productData);
                    }
                }
            }
        },
        async mounted() {
            try {
                NF.UI.Page.block();

                var referente = sessionStorage.getItem("Referente");
                referente == 'null' || referente == null ? this.referente = null : this.referente = referente;
                var medium = sessionStorage.getItem("Medium");
                medium == 'null' || medium == null ? this.medium = 'organic' : this.medium = medium;

                const parallelPromises = [
                    this.pageCustomization(),
                    this.updateByProductGoogleAnalytics()
                ];

                await Promise.all([
                    ...parallelPromises,
                ]);

                this.getInitData();

            } finally {
                NF.UI.Page.unblock();
            }
        },
    })
